"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsConfirmRevoke = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var index_1 = require("../../i18n/index");
var ACCOUNTS_REVOKE_SUCCESS = { key: index_1.T.ACCOUNTS_REVOKE_SUCCESS };
var AccountsConfirmRevoke = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsConfirmRevoke, _super);
    function AccountsConfirmRevoke(ctrl, invite) {
        var _this = _super.call(this, {
            title: index_1.T.ACCOUNTS_REVOKE_TITLE,
            confirm: index_1.T.ACCOUNTS_REVOKE,
            success: ACCOUNTS_REVOKE_SUCCESS
        }) || this;
        _this.ctrl = ctrl;
        _this.invite = invite;
        return _this;
    }
    Object.defineProperty(AccountsConfirmRevoke.prototype, "nodes", {
        get: function () {
            return (0, index_1.Translate)(index_1.T.ACCOUNTS_REVOKE_CONFIRM, this.invite.email);
        },
        enumerable: false,
        configurable: true
    });
    AccountsConfirmRevoke.prototype.submit = function () {
        return this.ctrl.removeUserInvite(this.invite);
    };
    AccountsConfirmRevoke.prototype.failToChange = function () {
        this.ctrl.setLoading(this.invite.objectId, false);
    };
    return AccountsConfirmRevoke;
}(modal_form_component_1.ModalFormComponent));
exports.AccountsConfirmRevoke = AccountsConfirmRevoke;
//# sourceMappingURL=accounts.confirm.revoke.js.map